import { render, staticRenderFns } from "./organization-audit-list.vue?vue&type=template&id=f3ab2b78&"
import script from "./organization-audit-list.vue?vue&type=script&lang=js&"
export * from "./organization-audit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports